const et = {
  nav: {
    about: 'Meist',
    services: 'Teenused',
    regions: 'Piirkonnad',
    whyUs: 'Miks Meid',
    contact: 'Kontakt',
    getStarted: 'Alusta',
  },
  hero: {
    heading: 'Rahvusvaheline Ärinõustamine ja Ärikontaktid',
    paragraph: 'TS Consulting aitab ettevõtetel luua ja arendada ärisuhteid Euroopas, Lähis-Idas, Kesk-Aasias ja Eestis. Toetame ettevõtteid uutele turgudele sisenemisel ning usaldusväärsete partnerite leidmisel.',
    contactButton: 'Võta Ühendust',
    learnButton: 'Loe lähemalt',
  },
  about: {
    badge: 'TS Consulting',
    heading: 'Rahvusvaheliste ärisidemete loomine',
    paragraph: 'TS Consulting aitab ettevõtetel luua usaldusväärseid rahvusvahelisi ärikontakte ja koostöösuhteid. Toetame ettevõtete vahelist koostööd Euroopa, Lähis-Ida, Kesk-Aasia ja Eesti turgudel ning aitame orienteeruda rahvusvahelise äritegevuse võimalustes ja väljakutsetes.',
  },
  services: {
    heading: 'Meie Teenused',
    subtitle: 'Lahendused ettevõtetele, kes soovivad arendada rahvusvahelist äritegevust.',
    card1Title: 'Ärikontaktide loomine',
    card1Description: 'Leiame ja ühendame teid usaldusväärsete partneritega erinevates riikides ja valdkondades, kasutades meie rahvusvahelist kontaktvõrgustikku.',
    card2Title: 'Rahvusvahelise kaubanduse tugi',
    card2Description: 'Aitame ettevõtetel toime tulla tollinõuete, regulatsioonide ja logistikaga, et piiriülene kaubandus toimiks sujuvalt.',
    card3Title: 'Turuühendused ja koostöö',
    card3Description: 'Pakume turuinfot ning aitame luua kohalolekut ja koostöösuhteid Euroopas, Lähis-Idas ja Kesk-Aasias.',
    card4Title: 'Strateegilised Investeeringud',
    card4Description: 'Strateegilised investeeringud kinnisvarasse ja tootmisse, keskendudes kaasaegsete tootmisrajatiste arendamisele.',
    learnMore: 'Lisateave',
  },
  regions: {
    badge: 'Rahvusvaheline haare',
    heading: 'Piirkonnad, Kus Tegutseme',
    europe: 'Euroopa',
    europeSubtitle: '',
    middleEast: 'Lähis-Ida',
    middleEastSubtitle: '',
    estonia: 'Eesti',
    estoniaSubtitle: '',
    egypt: 'Egiptus',
    egyptSubtitle: '',
    centralAsia: 'Kesk-Aasia',
    centralAsiaSubtitle: '',
  },
  whyUs: {
    heading: 'Miks Valida TS Consulting',
    reason1Title: 'Rahvusvaheline Ärivõrgustik',
    reason1Description: 'Ligipääs usaldusväärsetele partneritele ja otsustajatele mitmes strateegilises piirkonnas.',
    reason2Title: 'Piirkondade Turu Tundmine',
    reason2Description: 'Hea arusaam kohaliku äri keskkonnast, regulatsioonidest ja koostöövõimalustest.',
    reason3Title: 'Usaldusväärne Koostöö',
    reason3Description: 'Pikaajalised partnerlussuhted, mis põhinevad usaldusel, läbipaistvusel ja praktilistel tulemustel.',
    reason4Title: 'Personaalne Lähenemine',
    reason4Description: 'Iga klient ja projekt on erinev – pakume lahendusi, mis arvestavad teie ettevõtte eesmärke ja vajadusi.',
  },
  partners: {
    heading: 'Strateegilised Partnerid',
    description: 'Teeme koostööd usaldusväärsete organisatsioonidega Euroopas, Lähis-Idas ja Kesk-Aasias, et toetada rahvusvahelist äriarendust ja piiriülest koostööd.',
    supportText: 'Teeme koostööd hoolikalt valitud partneritega, kes jagavad meie pühendumust usaldusväärsusele, läbipaistvusele ja pikaajalisele koostööle.',
  },
  contact: {
    card1Heading: 'Võta Meiega Ühendust',
    card1Paragraph: 'Soovid laiendada oma äritegevust rahvusvaheliselt? Arutame võimalikke koostöövõimalusi.',
    card2Heading: 'Alusta Oma Rahvusvahelist Teekonda',
    card2Paragraph: 'Sisene uutele turgudele, leia usaldusväärseid partnereid või arenda rahvusvahelist koostööd, kõike seda koos TS Consultinguga.',
    scheduleButton: 'Broneeri Konsultatsioon',
    responseText: '',
  },
  footer: {
    aboutHeading: 'Meist',
    aboutText: 'TS Consulting aitab ettevõtetel luua rahvusvahelisi ärisuhteid ja leida uusi koostöövõimalusi erinevatel turgudel.',
    quickLinks: 'Kiirlingid',
    services: 'Teenused',
    regions: 'Piirkonnad',
    about: 'Meist',
    contact: 'Kontakt',
    copyright: '© 2026 TS Consulting. Kõik õigused kaitstud.',
    privacyPolicy: 'Privaatsuspoliitika',
    termsOfService: 'Kasutustingimused',
    cookiePolicy: 'Küpsiste Poliitika',
  },
  privacyPolicy: {
    title: 'Privaatsuspoliitika',
    lastUpdated: 'Viimati Uuendatud: Jaanuar 2025',
    introTitle: 'Sissejuhatus',
    introText: 'TS Consulting ("meie" või "me") on pühendunud teie privaatsuse kaitsmisele. See privaatsuspoliitika selgitab, kuidas me kogume, kasutame, avalikustame ja kaitseme teie teavet, kui külastate meie veebisaiti või kasutate meie teenuseid.',
    infoCollectTitle: 'Teave, Mida Me Kogume',
    infoCollectText: 'Kogume teavet, mida te meile otse esitate, sealhulgas nimi, e-posti aadress, telefoninumber, ettevõtte nimi ja mis tahes muu teave, mida otsustate esitada. Samuti kogume automaatselt teatud teavet teie seadme kohta, kui kasutate meie veebisaiti, sealhulgas IP-aadress, brauseri tüüp ja kasutusandmed.',
    howUseTitle: 'Kuidas Me Kasutame Teie Teavet',
    howUseText: 'Kasutame kogutud teavet meie teenuste pakkumiseks, haldamiseks ja parandamiseks; teiega suhtlemiseks meie teenuste kohta; teie päringutele vastamiseks; turundussõnumite saatmiseks (teie nõusolekul); ja seaduslike kohustuste täitmiseks.',
    dataProtectionTitle: 'Andmekaitse',
    dataProtectionText: 'Rakendame sobivaid tehnilisi ja organisatsioonilisi meetmeid teie isikuandmete kaitsmiseks volitamata juurdepääsu, muutmise, avalikustamise või hävitamise eest. Siiski ei ole ükski interneti-ülekande meetod 100% turvaline.',
    dataSharingTitle: 'Andmete Jagamine ja Avalikustamine',
    dataSharingText: 'Me ei müü teie isikuandmeid. Võime jagada teie teavet teenusepakkujatega, kes aitavad meil meie veebisaiti käitada ja äri juhtida, professionaalsete nõustajatega ning vastavalt seadusele või meie õiguste kaitsmiseks.',
    cookiesTitle: 'Küpsised ja Jälgimistehnoloogiad',
    cookiesText: 'Kasutame küpsiseid ja sarnaseid jälgimistehnoloogiaid, et jälgida tegevust meie veebisaidil ja hoida teatud teavet. Saate oma brauserile juhiseid anda keelduda kõigist küpsistest või näidata, millal küpsist saadetakse.',
    userRightsTitle: 'Teie Õigused',
    userRightsText: 'Sõltuvalt teie asukohast võivad teil olla teatud õigused seoses oma isikuandmetega, sealhulgas õigus juurdepääsule, parandamisele, kustutamisele või oma isikuandmete töötlemise piiramisele. Nende õiguste kasutamiseks võtke meiega ühendust allpool esitatud teabe abil.',
    dataRetentionTitle: 'Andmete Säilitamine',
    dataRetentionText: 'Säilitame teie isikuandmeid nii kaua, kui on vajalik selles privaatsuspoliitikas kirjeldatud eesmärkide täitmiseks, välja arvatud juhul, kui seadus nõuab või lubab pikemat säilitamisperioodi.',
    internationalTitle: 'Rahvusvahelised Andmeedastused',
    internationalText: 'Teie teavet võidakse edastada ja hoida arvutites, mis asuvad väljaspool teie riiki, kus andmekaitseseadused võivad erineda. Meie teenuste kasutamisega nõustute selle ülekandega.',
    changesTitle: 'Muudatused Selles Privaatsuspoliitikas',
    changesText: 'Võime aeg-ajalt seda privaatsuspoliitikat uuendada. Teavitame teid kõigist muudatustest, postitades uue privaatsuspoliitika sellele lehele ja uuendades kuupäeva "Viimati Uuendatud".',
    contactTitle: 'Võtke Meiega Ühendust',
    contactText: 'Kui teil on küsimusi selle privaatsuspoliitika kohta, võtke meiega ühendust: info@tsconsulting.com',
  },
  termsOfService: {
    title: 'Kasutustingimused',
    lastUpdated: 'Viimati Uuendatud: Jaanuar 2025',
    introTitle: 'Sissejuhatus',
    introText: 'Tere tulemast TS Consulting. Meie veebisaidi ja teenuste kasutamisel nõustute nende kasutustingimustega. Kui te ei nõustu nende tingimuste mis tahes osaga, ei tohi te meie teenustele juurde pääseda.',
    purposeTitle: 'Meie Veebisaidi Kasutamine',
    purposeText: 'Meie veebisait on mõeldud teabe pakkumiseks meie konsultatsiooniteenuste kohta ja äripäringute hõlbustamiseks. Nõustute kasutama meie veebisaiti ainult seaduslikel eesmärkidel ja vastavalt nendele tingimustele. Te ei tohi kasutada meie veebisaiti viisil, mis võib kahjustada, keelata või kahjustada meie teenuseid.',
    intellectualTitle: 'Intellektuaalne Omand',
    intellectualText: 'Kogu selle veebisaidi sisu, sealhulgas tekst, graafika, logod, pildid ja tarkvara, on TS Consulting või selle sisupakkujate omand ja on kaitstud rahvusvaheliste autoriõiguste seadustega. Te ei tohi meie sisu reprodutseerida, levitada ega luua tuletatud teoseid ilma selgesõnalise kirjaliku loata.',
    limitationTitle: 'Vastutuse Piiramine',
    limitationText: 'TS Consulting ei vastuta mis tahes kaudsete, juhuslike, eriliste, tagajärjeliste või karistuslike kahjude eest, mis tulenevad teie teenuste kasutamisest või võimetusest neid kasutada. Meie koguvastutus ei ületa summat, mille te olete maksnud, kui üldse, meie teenustele juurdepääsu eest.',
    externalTitle: 'Välised Lingid',
    externalText: 'Meie veebisait võib sisaldada linke kolmandate osapoolte veebisaitidele. Me ei vastuta kolmandate osapoolte saitide sisu, privaatsuspoliitikate ega tavade eest. Soovitame teil üle vaadata mis tahes kolmandate osapoolte veebisaitide tingimused ja poliitikad, mida külastate.',
    changesTitle: 'Muudatused Tingimustes',
    changesText: 'Jätame endale õiguse neid kasutustingimusi igal ajal muuta. Muudatused jõustuvad kohe pärast veebisaidile postitamist. Teie jätkuv teenuste kasutamine pärast muudatuste postitamist tähendab muudetud tingimustega nõustumist.',
    governingTitle: 'Kohaldatav Õigus',
    governingText: 'Neid tingimusi reguleeritakse ja tõlgendatakse vastavalt kohaldatavatele rahvusvahelistele äriõiguse normidele, arvestamata selle õiguskollisioonide sätteid.',
    contactTitle: 'Võtke Meiega Ühendust',
    contactText: 'Kui teil on küsimusi nende kasutustingimuste kohta, võtke meiega ühendust: info@tsconsulting.com',
  },
  cookiePolicy: {
    title: 'Küpsiste Poliitika',
    lastUpdated: 'Viimati Uuendatud: Jaanuar 2025',
    whatAreTitle: 'Mis On Küpsised',
    whatAreText: 'Küpsised on väikesed tekstifailid, mis paigutatakse teie seadmesse, kui külastate veebisaiti. Neid kasutatakse laialdaselt, et veebisaidid töötaksid tõhusamalt ja annaksid teavet veebisaidi omanikele.',
    howUseTitle: 'Kuidas Me Kasutame Küpsiseid',
    howUseText: 'Kasutame küpsiseid, et mõista, kuidas te meie veebisaiti kasutate, meeles pidada teie eelistusi, parandada teie kogemust ja analüüsida veebisaidi liiklust. Küpsised aitavad meil pakkuda teile paremat ja isikupärastatud teenust.',
    typesTitle: 'Küpsiste Tüübid, Mida Me Kasutame',
    essentialTitle: 'Hädavajalikud Küpsised',
    essentialText: 'Need küpsised on vajalikud veebisaidi nõuetekohaseks toimimiseks. Need võimaldavad põhifunktsioone nagu lehel navigeerimine ja juurdepääs veebisaidi turvatsoondele.',
    analyticsTitle: 'Analüütikaküpsised',
    analyticsText: 'Need küpsised aitavad meil mõista, kuidas külastajad meie veebisaidiga suhtlevad, kogudes ja teatades teavet anonüümselt. Kasutame neid andmeid oma veebisaidi jõudluse parandamiseks.',
    functionalTitle: 'Funktsionaalsed Küpsised',
    functionalText: 'Need küpsised võimaldavad täiustatud funktsionaalsust ja isikupärastamist, näiteks teie keeleeelistuse ja muude kohandamisvalikute meeldejätmist.',
    managingTitle: 'Küpsiste Haldamine',
    managingText: 'Enamik veebibrausereid võimaldab teil küpsiseid hallata nende seadete kaudu. Saate seadistada oma brauseri keelduda küpsistest või kustutada teatud küpsiseid. Kui te aga küpsised keelete, ei pruugi mõned meie veebisaidi funktsioonid korralikult töötada.',
    updatesTitle: 'Selle Poliitika Uuendused',
    updatesText: 'Võime seda küpsiste poliitikat aeg-ajalt uuendada, et kajastada muudatusi tehnoloogias või õiguslike nõuete osas. Palun vaadake seda lehte perioodiliselt üle võimalike uuenduste osas.',
    contactTitle: 'Võtke Meiega Ühendust',
    contactText: 'Kui teil on küsimusi meie küpsiste kasutamise kohta, võtke meiega ühendust: info@tsconsulting.com',
  },
};

export default et;